import { PropTypes } from 'react';

const TableFooter = ({ children }) => (
    <footer className="cn-table__footer">
        {children}
    </footer>
);

TableFooter.propTypes = {
    children: PropTypes.node
};

export default TableFooter;



// WEBPACK FOOTER //
// ./app/components/table/footer.jsx